import { message, Upload } from "antd";

export const validateImage = (file) => {
  const isAnImage = file.type.includes("image");

  if (!isAnImage) {
    message.error("El archivo no es una imagen válida");
  }

  return isAnImage || Upload.LIST_IGNORE;
};
